import FullCalendar, {
    EventApi,
    EventClickArg,
    EventSourceInput,
} from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ReactDOM from "react-dom";
import React, {
    Dispatch,
    SetStateAction,
    useEffect,
    useRef,
    useState,
} from "react";
import { Spinner } from "../../Loding/SpinnerPadrao";

import "./styles.css";
import CriarAgendamento from "../../CardsPages/Atendimento/CriarAgendamento";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faExchangeAlt,
    faInfoCircle,
    faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { IComponentModal } from "../../Modais/IModalComponent";

import { IAtendimentoExtraDetalhado } from "../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import ModalComponent from "../../Modais";
import {
    IAgendaCompromisso,
    IFiltroListarAgendamento,
} from "../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import { getXMonthsAgoDate } from "../../../Tools/DateTools";
import { useUserInfor } from "../../../Context/User";
import GerarRelatorioManutencao from "../../CardsPages/GerarRelatorioManutencao";
import TransferirAgendamentosMassa from "../../CardsPages/Atendimento/TransferirAgendamentosMassa";
import EventosModal, { EventoModalGrupoHeader } from "../EventosModal";
interface IFiltroDeData
    extends Pick<IFiltroListarAgendamento, "DT_INICIO" | "DT_FIM"> {}

interface IFiltrosDeAgendamento
    extends Omit<
        IFiltroListarAgendamento,
        "DT_INICIO" | "DT_FIM" | "FL_APENAS_MEUS_AGENDAMENTOS"
    > {}
interface IAgendaComponentProps {
    events?: EventSourceInput;
    eventsTooltip?: (event: EventApi) => React.ReactNode;
    eventClick?: (arg: EventClickArg) => void;
    filtroListarAgendamento: IFiltrosDeAgendamento;
    listarAgendamentos: (
        filtrosDeData: IFiltroDeData
    ) => Promise<IAgendaCompromisso[]>;
    Atendimento?: IAtendimentoExtraDetalhado;
    responsivo?: boolean;
    setAtualizaAgenda: Dispatch<SetStateAction<boolean>>;
    loading: boolean;
    setLoading: Dispatch<SetStateAction<boolean>>;
}

function InfoModalGabarito() {
    return (
        <ul className="list-group">
            <li className="list-group-item d-flex justify-content-between align-items-center">
                Solicitação de manutenção <span>🟠</span>
            </li>
            <li className="list-group-item d-flex justify-content-between align-items-center">
                Avaliação de procedência <span>🟡</span>
            </li>
            <li className="list-group-item d-flex justify-content-between align-items-center">
                Agendamento de vistoria <span>🔵</span>
            </li>
            <li className="list-group-item d-flex justify-content-between align-items-center">
                Execução de vistoria <span>🟣</span>
            </li>
            <li className="list-group-item d-flex justify-content-between align-items-center">
                Sem atendimento <span>⚫</span>
            </li>
        </ul>
    );
}

export default function AgendaComponent(props: IAgendaComponentProps) {
    const [show, setShow] = useState(false);
    const [titleModal, setTitleModal] = useState("");
    const [modal, setModal] = useState<IComponentModal>();

    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;

    const emccampMode = "E830AEF3-49DF-4DC1-8560-DC78EE448F01";
    const calendarRef = useRef<FullCalendar>(null);

    useEffect(() => {
        const calendarApi = calendarRef.current?.getApi();
        if (calendarApi) {
            const updateCalendar = () => {
                const viewTitle = calendarApi.view.title; // Obtém o título da visualização atual
                setTitleModal(
                    viewTitle.charAt(0).toUpperCase() + viewTitle.slice(1)
                );
            };

            calendarApi.on("datesSet", updateCalendar); // Atualiza o calendário quando as datas forem modificadas
        }
    }, []);

    return (
        <>
            <div
                className={`position-relative ${
                    props.responsivo ? "responsive" : "notResponsive"
                }`}
            >
                {!props.responsivo ? (
                    <div className="d-flex justify-content-between">
                        <div className="d-flex align-items-center">
                            <h1>
                                <span className="card-label font-weight-bolder text-dark gruposTitle">
                                    Minha Agenda
                                </span>
                            </h1>
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="ver-info-tooltip">
                                        Cores do gabarito
                                    </Tooltip>
                                }
                            >
                                <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    className="text-warning mb-3 ml-2 hover-effect"
                                    size="2x"
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            headerComponent: "Gabarito",
                                            IconHeader: faInfoCircle,
                                            Component: () => (
                                                <InfoModalGabarito />
                                            ),
                                            size: "sm",
                                        });
                                    }}
                                />
                            </OverlayTrigger>
                        </div>

                        <div className="d-flex justify-content-end flex-wrap mt-4">
                            <button
                                className="btn btn-success d-flex align-items-center justify-content-center flex-nowrap g-2 mb-3"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Criar Agendamento",
                                        IconHeader: faPlus,
                                        Component: () => (
                                            <CriarAgendamento
                                                updateList={() =>
                                                    props.listarAgendamentos({
                                                        DT_FIM: new Date(),
                                                        DT_INICIO: new Date(
                                                            getXMonthsAgoDate(1)
                                                        ),
                                                    })
                                                }
                                                setAtualizaAgenda={
                                                    props.setAtualizaAgenda
                                                }
                                                setShow={setShow}
                                                Atendimento={props.Atendimento}
                                                ID_TIPO_COMPROMISSO={3}
                                            />
                                        ),
                                        size: "lg",
                                    });
                                }}
                            >
                                Novo Agendamento
                                <span>
                                    <FontAwesomeIcon icon={faPlus} />
                                </span>
                            </button>
                            <button
                                className="btn btn-primary d-flex align-items-center justify-content-center flex-nowrap g-2 mb-3 ml-2"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent:
                                            "Transferir Todos os Agendamentos",
                                        IconHeader: faExchangeAlt,
                                        Component: () => (
                                            <TransferirAgendamentosMassa
                                                updateList={() =>
                                                    props.listarAgendamentos({
                                                        DT_FIM: new Date(),
                                                        DT_INICIO: new Date(
                                                            getXMonthsAgoDate(1)
                                                        ),
                                                    })
                                                }
                                                setAtualizaAgenda={
                                                    props.setAtualizaAgenda
                                                }
                                                setShow={setShow}
                                            />
                                        ),
                                        size: "lg",
                                    });
                                }}
                            >
                                Transferir Todos os Agendamentos
                                <span>
                                    <FontAwesomeIcon icon={faExchangeAlt} />
                                </span>
                            </button>
                        </div>
                    </div>
                ) : null}
                {props.responsivo && (
                    <h2 className="d-flex justify-content-center">
                        {titleModal}
                    </h2>
                )}

                <FullCalendar
                    ref={calendarRef}
                    plugins={[
                        dayGridPlugin,
                        timeGridPlugin,
                        bootstrapPlugin,
                        interactionPlugin,
                    ]}
                    events={props.events}
                    height="auto"
                    contentHeight="auto"
                    themeSystem="bootstrap"
                    locales={[
                        {
                            code: "pt-br",
                            allDayText: "Dia Todo",
                            allDayClassNames: "ws-nowrap",
                            buttonText: {
                                day: "Dia",
                                month: "Mês",
                                today: "Hoje",
                                week: "Semana",
                            },
                        },
                    ]}
                    // isso é necessário para adicionar tooltip para os eventos
                    eventDidMount={(args) => {
                        // cria um componente que é um overlayTrigger do componente html
                        const eventComponent = (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip
                                        id={`tooltip-agenda-evento-${args.event.id}`}
                                    >
                                        {props.eventsTooltip
                                            ? props.eventsTooltip(args.event)
                                            : args.event.title}
                                    </Tooltip>
                                }
                            >
                                <span
                                    style={{
                                        overflow: "hidden",
                                    }}
                                    className="d-flex align-items-center w-100 mh-100 align-items-baseline"
                                    dangerouslySetInnerHTML={{
                                        __html: args.el.innerHTML,
                                    }}
                                />
                            </OverlayTrigger>
                        );
                        ReactDOM.render(eventComponent, args.el);
                    }}
                    dayMaxEvents={5}
                    moreLinkText={(c) => {
                        return `+ Ver mais`;
                    }}
                    moreLinkClick={(arg) => {
                        setShow(true);
                        setModal({
                            customHeader: EventoModalGrupoHeader(arg),
                            Component: () => (
                                <EventosModal
                                    setShow={setShow}
                                    filtroListarAgendamento={
                                        props.filtroListarAgendamento
                                    }
                                    arg={arg}
                                />
                            ),
                            size: "xl",
                        });
                        // retorno para ignorar o defaultValue do popover (gambiarra) para mais detalhes olhe a documentação
                        return "semPopover";
                    }}
                    loading={props.setLoading}
                    eventClick={props.eventClick}
                    expandRows={true}
                    eventMaxStack={2}
                    slotEventOverlap={false}
                    headerToolbar={{
                        left: `${props.responsivo ? "prev,next" : "title"}`,
                        right: `${
                            props.responsivo
                                ? "today dayGridMonth,timeGridWeek,timeGridDay"
                                : "prev,next today dayGridMonth,timeGridWeek,timeGridDay"
                        }`,
                    }}
                />

                {props.loading && (
                    <span
                        className="position-absolute"
                        style={{
                            left: "50%",
                            top: "50%",
                        }}
                    >
                        <Spinner color="primary" />
                    </span>
                )}
                <div className="d-flex flex-row justify-content-end flex-wrap mt-4">
                    {emccampMode === ID_ORGANIZACAO ? (
                        <div
                            className={`d-flex ${
                                props.responsivo
                                    ? "flex-column"
                                    : "flex-row g-2"
                            }`}
                        >
                            <button
                                className="btn btn-primary d-flex align-items-center justify-content-center flex-nowrap g-2 mb-3"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Gerar Relatório",
                                        IconHeader: faPlus,
                                        Component: () => (
                                            <GerarRelatorioManutencao
                                                sistema={true}
                                            />
                                        ),
                                        size: "sm",
                                    });
                                }}
                            >
                                Gerar relatório de solicitações de vistorias
                                para a impressão com sistema
                            </button>
                            <button
                                className="btn btn-info d-flex align-items-center justify-content-center flex-nowrap g-2 mb-3"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Gerar Relatório",
                                        IconHeader: faPlus,
                                        Component: () => (
                                            <GerarRelatorioManutencao
                                                sistema={false}
                                            />
                                        ),
                                        size: "sm",
                                    });
                                }}
                            >
                                Gerar relatório de solicitações de vistorias
                                para a impressão sem sistema
                            </button>
                        </div>
                    ) : null}
                    {props.responsivo ? (
                        <>
                            <button
                                className="btn btn-success d-flex align-items-center justify-content-center flex-nowrap g-2 mb-3 w-100"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Criar Agendamento",
                                        IconHeader: faPlus,
                                        Component: () => (
                                            <CriarAgendamento
                                                updateList={() =>
                                                    props.listarAgendamentos({
                                                        DT_FIM: new Date(),
                                                        DT_INICIO: new Date(
                                                            getXMonthsAgoDate(1)
                                                        ),
                                                    })
                                                }
                                                setAtualizaAgenda={
                                                    props.setAtualizaAgenda
                                                }
                                                setShow={setShow}
                                                Atendimento={props.Atendimento}
                                                ID_TIPO_COMPROMISSO={3}
                                            />
                                        ),
                                        size: "lg",
                                    });
                                }}
                            >
                                Novo Agendamento
                                <span>
                                    <FontAwesomeIcon icon={faPlus} />
                                </span>
                            </button>
                            <button
                                className="btn btn-primary d-flex align-items-center justify-content-center flex-nowrap g-2 mb-3 w-100"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent:
                                            "Transferir Todos os Agendamentos",
                                        IconHeader: faExchangeAlt,
                                        Component: () => (
                                            <TransferirAgendamentosMassa
                                                updateList={() =>
                                                    props.listarAgendamentos({
                                                        DT_FIM: new Date(),
                                                        DT_INICIO: new Date(
                                                            getXMonthsAgoDate(1)
                                                        ),
                                                    })
                                                }
                                                setAtualizaAgenda={
                                                    props.setAtualizaAgenda
                                                }
                                                setShow={setShow}
                                            />
                                        ),
                                        size: "lg",
                                    });
                                }}
                            >
                                Transferir Todos os Agendamentos
                                <span>
                                    <FontAwesomeIcon icon={faExchangeAlt} />
                                </span>
                            </button>
                        </>
                    ) : null}
                </div>
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
